<!--
 * @Author: Kevin
 * @Date: 2017-08-23 10:00:50
 * @LastEditors: Kevin
 * @LastEditTime: 2022-07-26 11:53:02
 * @Description:
-->
<template>
  <footer class="footer">
    <div class="container">
      <div class="col-lg-10 col-lg-offset-1">
        <div class="col-md-3 col-sm-3 col-xs-4 footer-logo">
          <img src="../../../src/assets/images/footer-left.png" alt="">
        </div>
        <div class="col-md-3 col-sm-3 col-xs-6 col-md-offset-0 col-sm-offset-0 col-xs-offset-1 footer-contents">
          <ol class="address-infos">
            <li class="row">
              <span class="col-md-4 col-sm-5 col-xs-4">{{$t("footer.tel_label")}}</span>
              <p class="col-md-8 col-sm-7 col-xs-8">{{$t("footer.tel_val")}}</p>
            </li>
            <li class="row">
              <span class="col-md-4 col-sm-5 col-xs-4">{{$t("footer.email_label")}}</span>
              <p class="col-md-8 col-sm-7 col-xs-8">devops@tintinhealth.com</p>
            </li>
            <li class="row">
              <span class="col-md-4 col-sm-5 col-xs-4">{{$t("footer.company_address_label")}}</span>
              <p class="col-md-8 col-sm-7 col-xs-8">{{$t("footer.company_address")}}</p>
            </li>
          </ol>
        </div>
        <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1 col-sm-offset-0">
          <ol class="row  qr-code-wrap">
            <!-- <li class="codeImg col-md-offset-6 col-sm-offset-6 col-md-3 col-sm-3 col-xs-offset-3 col-xs-3">
              <img src="../../../src/assets/images/web_andriod.png" alt="">
            </li> -->
            <li class="codeImg col-md-3 col-sm-3 col-xs-3">
              <img src="../../../src/assets/images/web_andriod.png" alt="">
            </li>
            <li class="col-md-12 col-sm-12 col-xs-12">
              <p>{{$t("footer.copyright")}}</p>
              <p>{{$t("footer.case_number")}}</p>
            </li>
          </ol>

        </div>
      </div>

    </div>
  </footer>
</template>

<script>
    export default {
        name: 'footer',
        data () {
            return {}
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../../assets/css/style.css';
  .qr-code-wrap{overflow: hidden;}
  .codeImg{
    float: right;
  }
</style>



// WEBPACK FOOTER //
// Footer.vue?68ec1998